/*------------------------------------------------------------------
External
------------------------------------------------------------------*/

import $ from 'cash-dom';


/*------------------------------------------------------------------
Internal
------------------------------------------------------------------*/

import * as template from './templates';


/*------------------------------------------------------------------
Functionality
------------------------------------------------------------------*/

$(() => {
    let $body = $('body');

    $body.on('mouseenter', '[data-tooltip]', (e) => {
        let $this = $(e.currentTarget);
        $this.append(template.tooltip($this.data('tooltip')));
        setTimeout(() => $this.addClass('tooltipActive'), 10);
    });

    $body.on('mouseleave', '[data-tooltip]', (e) => {
        let $this = $(e.currentTarget);
        $this.removeClass('tooltipActive');
        setTimeout(() => $this.find('.tooltip').remove(), 333);
    });

});

